import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { useHistory } from 'react-router-dom';
import { v4 as uuidV4 } from 'uuid';
import './nav.scss';

const useStyles = makeStyles({
  root: {
    width: 500,
  },
});

export default function SimpleBottomNavigation({ router, cmsNavBar, claims, contracts, DesktopType, loading }) {
  const classes = useStyles();

  const [value, setValue] = React.useState(0);
  const history = useHistory();

  const getTotalNbClaims = () => {
    let totalNbClaims = 0;
    if (contracts) {
      for (let i = 0; i < contracts?.length; i++) {
        totalNbClaims += contracts[i]?.nbClaims;
      }
    }
    return totalNbClaims;
  };
  const totalNbClaims = getTotalNbClaims();

  const syncData = (val, attributeKey) => {
    const resulta = cmsNavBar?.data?.items?.find(v => v.code === val?.code?.toString());
    if (resulta) {
      switch (attributeKey) {
        case 'LABEL':
          switch (val.code) {
            case 1:
              return (location.pathname.includes('/contracts') || location.pathname.includes('/document') || location.pathname.includes('/contact') || location.pathname.includes('/claims') ) && contracts.length === 1
                ? resulta.label
                : resulta.label_plural !== null
                ? resulta.label_plural
                : resulta.label;
            case 2:
              switch (location.pathname) {
                case '/claims':
                  return  claims.length=== 1
                    ? resulta.label
                    : resulta.label_plural !== null
                    ? resulta.label_plural
                    : resulta.label;
                default :
                  return totalNbClaims === 1
                    ? resulta.label
                    : resulta.label_plural !== null
                    ? resulta.label_plural
                    : resulta.label;
               
              }

          
            default:
              return resulta.label;
          }
        case 'ICON':
          return resulta.icon;
        default:
          return '';
      }
    }
  };

  useEffect(() => {
    const navBarItem = router.find(route => location.pathname.includes(route?.url));

    if (navBarItem) {
      setValue(navBarItem?.code - 1);
    }
  }, [location.pathname]);

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      showLabels
      className="navigate"
    >
      {DesktopType === 'CUSTOMER'
        ? contracts.length !== 0 && DesktopType === 'CUSTOMER'
          ? contracts?.some(el => el.nbClaims !== 0) && DesktopType === 'CUSTOMER'
            ? router?.map(item => (
                <BottomNavigationAction
                  key={uuidV4()}
                  label={syncData(item, 'LABEL')}
                  className="styletext"
                  onClick={() => {
                    if (history.location.pathname === item.url) {
                      history.go(0);
                    } else {
                      history.push(item.url);
                    }
                  }}
                />
              ))
            : router
                ?.filter(el => el.code !== 2)
                .map(item => (
                  <BottomNavigationAction
                    key={uuidV4()}
                    label={syncData(item, 'LABEL')}
                    className="styletext"
                    onClick={() => {
                      if (history.location.pathname === item.url) {
                        history.go(0);
                      } else {
                        history.push(item.url);
                      }
                    }}
                  />
                ))
          : router
              ?.filter(el => el.code === 3)
              .map(item => (
                <BottomNavigationAction
                  key={uuidV4()}
                  label={syncData(item, 'LABEL')}
                  className="styletext"
                  onClick={() => {
                    if (history.location.pathname === item.url) {
                      history.go(0);
                    } else {
                      history.push(item.url);
                    }
                  }}
                />
              ))
        : router.map(item => (
            <BottomNavigationAction
              key={uuidV4()}
              label={syncData(item, 'LABEL')}
              className="styletext"
              onClick={() => {
                history.push(item.url);
              }}
            />
          ))}
    </BottomNavigation>
  );
}
